let palette = ['#FF0000', '#FFFF00', '#00FF00', '#00FFFF', '#E62323', '#FF00FF', '#00AE5D', '#627ABC', '#F24941', '#7519FF', '#9BE6FD', '#FFBCD2', '#FF7474', '#7B5436', '#550C90', '#B622B5', '#116B2B', '#998E00'];
export default palette;


// WEBPACK FOOTER //
// ./src/UI/Palette/Palette.js